import React, { useState } from 'react';
import { ShieldCheck } from 'lucide-react';

interface VerifiedBadgeProps {
  size?: 'sm' | 'md' | 'lg';
  showTooltip?: boolean;
  className?: string;
}

const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({
  size = 'md',
  showTooltip = true,
  className = ''
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const sizeClasses = {
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const iconSizes = {
    sm: 12,
    md: 16,
    lg: 20
  };

  return (
    <div className={`relative inline-flex ${className}`}>
      <div
        className={`
          ${sizeClasses[size]}
          bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700
          border-2 border-blue-400
          rounded-full flex items-center justify-center cursor-help
          transition-all duration-300 hover:scale-110
          shadow-lg
        `}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <ShieldCheck size={iconSizes[size]} className="text-white" strokeWidth={2.5} />
      </div>

      {showTooltip && isHovered && (
        <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 z-50 w-64 pointer-events-none animate-fade-in">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white text-xs rounded-lg p-3 shadow-2xl border border-blue-400/20 ring-1 ring-blue-400/10">
            <div className="font-semibold mb-1 flex items-center gap-1">
              <ShieldCheck size={12} className="text-blue-400" />
              Verified Identity
            </div>
            <div className="text-white/80">
              This user has verified their identity with Veriff ID verification
            </div>
          </div>
          <div className="w-2 h-2 bg-gray-900 absolute left-1/2 -translate-x-1/2 -bottom-1 rotate-45 border-r border-b border-blue-400/20"></div>
        </div>
      )}
    </div>
  );
};

export default VerifiedBadge;
